import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const publishDraft = async (draftId, html) => {
    if (!draftId) {
        throw new Error("Invalid draftId");
    }

    try {
        const accessToken = await retrieveAccessToken();
        await axios.post(`/api/editor/draft/publish/${draftId}`,
            html,
            {
                headers: {
                    'Content-Type': 'text/html',
                    'Authorization': `Bearer ${accessToken}`
                }
            }

        );
        return { success: true }; // Resolve with success if the request is successful
    } catch (error) {
        // Handle HTTP errors or unexpected errors
        if (error.response) {
            throw new Error(`Error publishing draft: ${error.response.status} ${error.response.statusText}`);
        } else {
            throw new Error(`Network error: ${error.message}`);
        }
    }
};

export {publishDraft}
